import {
	DEALETGETLISTDSRMASTER_SUCCESS,
	DEALETGETLISTDSRMASTER_FAILED,
	RESET_DEALETGETLISTDSRMASTER,
	LOADING_DEALETGETLISTDSRMASTER,
	NETWORK_ERROR_DEALETGETLISTDSRMASTER
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerGetListDsrMaster = () => {
	return { type: RESET_DEALETGETLISTDSRMASTER };
};

const dealerGetListDsrMaster = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_DEALETGETLISTDSRMASTER });
	await dealerServices
		.post("getListDsrMaster", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(dealerGetListDsrMastersuccess(res.data));
					break;
				default:
					dispatch(dealerGetListDsrMasterFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_DEALETGETLISTDSRMASTER,
				payload: err
			});
		});
};
function dealerGetListDsrMastersuccess(data) {
	return {
		type: DEALETGETLISTDSRMASTER_SUCCESS,
		payload: data
	};
}
function dealerGetListDsrMasterFailed(data) {
	return {
		type: DEALETGETLISTDSRMASTER_FAILED,
		payload: data
	};
}

export { resetDealerGetListDsrMaster, dealerGetListDsrMaster };
